/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMutation } from 'data-fetching-client';
import { addAlert } from '../../utils/alerts';
import { useTracker } from '../../utils/usageTracker';
import { RESUME_SUBSCRIPTION } from './resumeSubscriptionApi';
import { jsx as _jsx } from "react/jsx-runtime";
export function useResumeSubscription({
  objectId,
  proposedNextBillingDate,
  onClose
}) {
  const {
    trackPauseChange
  } = useTracker();
  return useMutation(RESUME_SUBSCRIPTION, {
    variables: {
      objectId,
      proposedNextBillingDate
    },
    fetchPolicy: 'network-only',
    onError: async () => {
      addAlert({
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.ResumeSubscriptionModal.errorResumingTitle"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.ResumeSubscriptionModal.errorResumingMessage"
        }),
        type: 'danger'
      });
      await onClose();
    },
    onCompleted: async () => {
      trackPauseChange({
        subType: 'pause',
        action: 'resumeSubscriptionModalSubmitted',
        status: 'RESUMED'
      });
      addAlert({
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.ResumeSubscriptionModal.successfullyResumedTitle"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.ResumeSubscriptionModal.successfullyResumedMessage"
        }),
        type: 'success'
      });
      await onClose();
    }
  });
}